function showShearCheckSummary(project, results) {
    var design = project.design;
    var checks = results["shear_checks"];
    var controlling_unity = checks["controlling_unity"];
    var controlling_case = checks["controlling_case"];
    var controlling_Vu = checks["controlling_Vu"];
    var controlling_Vn = checks["controlling_Vn"];
    var controlling_equation = checks["controlling_code_equation"];
    var controlling_case = checks["controlling_case"];
    var controlling_location = checks["controlling_loc"];
    
    const nice_eq_index = Number(controlling_case.split('EQ')[1])

    var nice_case = design.loadCombination["prettyEquations"][nice_eq_index-1]["EQ"];
    var success = controlling_unity < 1.0;
    var designStatusStr = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
    configureCardAppearance('shear-design-panel', success)

    let str = `
        <div class="card-header">
            <div class="fs-6">
                ${designStatusStr} Shear
                <span class="float-end">${controlling_unity.toFixed(2)}</span>
            </div>
        </div>`
        
    str += "<div class='bg-white rounded-2'><table class='table table-borderless'>";

    str += "<tr>";
    if(project.isEngineeredLumber) {
        str += "<td>Vu (Demand)</td>";
        str += "<td><span style='float:right;'>" + showBigPointLoad(controlling_Vu);
        str += " " + bigPointLoadUnit() + "</span></td></tr>";

        str += "<tr>";
        if(project.shape.flitch) {
            str += "<td>Vn + Vn<sub>steel</sub> (Capacity)</td>";
        } else {
            str += "<td>Vn (Capacity)</td>";
        }
        str += "<td><span style='float:right;'>" + showBigPointLoad(controlling_Vn);
        str += " " + bigPointLoadUnit() + "</span></td></tr>";
        if(project.shape.flitch) {
            str += "<tr>";
            str += "<td>Vn<sub>steel</sub> (Capacity)";
            str += "<td><span style='float:right;'>0.6 &middot; Fy &middot; A<sub>steel</sub></td></tr>";
        }
    } else if(project.isNorthAmericanSteel || design.designType === 'None') {
        var demandStr = (project.isASD) ? "Vr" : "Vu";
        str += "<td>" + demandStr + " (Demand)</td>";
        str += "<td><span style='float:right;'>" + showBigPointLoad(controlling_Vu);
        str += " " + bigPointLoadUnit() + "</span></td></tr>";

        str += "<tr>";
        var capacityStr = (project.isASD) ? "Vn/&Omega;" : "&Phi;Vn";
        if(project.isNoDesign) { capacityStr = "Vn"; }
        str += "<td>" + capacityStr + " (Capacity)</td>";
        str += "<td><span style='float:right;'>" + showBigPointLoad(controlling_Vn);
        str += " " + bigPointLoadUnit() + "</span></td></tr>";
    } else {
        // note our wood design checks are actually returning shear stress not
        // shear force
        str += "<td>fv (Demand)</td>";
        str += "<td><span style='float:right;'>" + Number(controlling_Vu).toFixed(2);
        str += " psi" + "</span></td></tr>";

        str += "<tr>";
        str += "<td>F'v (Capacity)</td>";
        str += "<td><span style='float:right;'>" + Number(controlling_Vn).toFixed(2);
        str += " psi" + "</span></td></tr>";
    }

    str += "<tr>";
    str += "<td>Controlling Equation</td>";
    if(project.isEngineeredLumber) { 
        if(project.shape.flitch) {
            str += "<td><span style='float:right;'>Vu &le; Vn + Vn<sub>steel</sub>";
        } else {
            str += "<td><span style='float:right;'>Vu &le; Vn";
        }   
    } else if(project.isFormTechShape) {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    } else if(project.isNoDesign) {
        str += "<td><span style='float:right;'>Vn = Fy &bull; A &bull; 0.6";
    } else {
        str += "<td><span style='float:right;'>"+ controlling_equation +"</span></td></tr>";
    }

    str += "<tr>";
    str += "<td>Location</td>";
    str += "<td><span style='float:right;'>"+ showLengthWithUnits(controlling_location) +"</span></td></tr>";

    str += "<tr>";
    str += "<td>Load Combination</td>";
    str += "<td><span style='float:right;'>" + nice_case  +"</span></td></tr>";

    str += "</table></div>";

    document.getElementById('shear-design-panel').innerHTML = str
}
